<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="分类">
          <el-select size="small" v-model="searchForm.type" placeholder="所有分类">
            <el-option label="全部" value="ALL"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加申请-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" v-auth="'/setting/applyment/add'">添加</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="applymentNo" label="申请编号" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applymentTypeText" label="申请类型" width="160"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierName" label="商户名称" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column label="申请状态" width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.applymentStatus === 41">{{ scope.row.applymentStatusText }}</span>
              <span class="orange" v-else>{{ scope.row.applymentStatusText }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="applymentResult" label="申请状态消息"></el-table-column>
          <el-table-column label="签约链接" width="140" :render-header="renderHeaderMethods">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic" style="width: 140px;height: 140px;background: transparent">
                  <img v-img-url="scope.row.signUrl" alt=""/></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="checkTime" label="审核时间" width="140"></el-table-column>
          <el-table-column prop="createTime" label="申请时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="60">
            <template slot-scope="scope">
              <div class="table-btn-column">
                <el-button v-if="scope.row.applymentStatus === 10" @click="applyClick(scope.row,'apply')" type="text"
                           size="small"
                           v-auth="'/setting/applyment/apply'">申请
                </el-button>
                <el-button
                  v-if="scope.row.applymentStatus === 20 || scope.row.applymentStatus === 22 || scope.row.applymentStatus === 52"
                  @click="applyClick(scope.row,'rollback')" type="text" size="small"
                  v-auth="'/setting/applyment/rollback'">
                  撤回
                </el-button>
                <el-button v-if="scope.row.applymentStatus === 40" @click="checkStatus(scope.row)" type="text"
                           size="small"
                           v-auth="'/setting/applyment/edit'">状态查询
                </el-button>
                <el-button v-if="scope.row.applymentStatus === 10" @click="editClick(scope.row)" type="text"
                           size="small"
                           v-auth="'/setting/applyment/edit'">编辑
                </el-button>
                <el-button @click="viewClick(scope.row)" type="text" size="small"
                           v-auth="'/setting/applyment/edit'">查看
                </el-button>
                <el-button v-if="scope.row.applymentStatus === 10" @click="deleteClick(scope.row)" type="text"
                           size="small" v-auth="'/setting/applyment/delete'">删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SubApplymentApi from '@/api/subApplyment.js';

export default {
  data() {
    return {
      /*搜索参数*/
      searchForm: {
        name: '',
        type: 'ALL'
      },
      /*是否加载完成*/
      loading: true,
      content: 'true',
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    renderHeaderMethods(h, {column}) {
      return h(
        'div',
        {
          style: 'display:flex;margin:auto;'
        },
        [
          h('span', column.label),
          h('promptMessages', {
            // 引用 promptMessages 全局组件
            props: {
              // messages 里面配置的信息即为 Tooltip 提示信息
              messages: ['1、超级管理员用微信扫码，关注“微信支付商家助手”公众号后，公众号将自动发送签约消息；超管需点击消息，根据指引完成核对联系信息、账户验证、签约等操作。',
                '2、超管完成核对联系信息，后续申请单进度可通过公众号自动通知超级管理员。']
            }
          })
        ]
      );
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      SubApplymentApi.applymentList(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.records;
          self.totalDataNumber = res.data.total;
        })
        .catch(error => {
        });
    },
    /*打开添加*/
    addClick() {
      this.$router.push('/setting/applyment/add');
    },
    /*打开编辑*/
    checkStatus(item) {
      let self = this;
      this.$router.push({
        path: '/setting/applyment/edit',
        query: {
          applymentId: item.applymentId
        }
      });
    },
    editClick(item) {
      let self = this;
      this.$router.push({
        path: '/setting/applyment/edit',
        query: {
          applymentId: item.applymentId,
          applymentType: item.applymentType,
          op: 'edit',
        }
      });
    },
    viewClick(item) {
      let self = this;
      this.$router.push({
        path: '/setting/applyment/edit',
        query: {
          applymentId: item.applymentId,
          applymentType: item.applymentType,
          op: 'view',
        }
      });
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          SubApplymentApi.deleteApplyment(
            {
              id: row.applymentId
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getData();
            })
            .catch(error => {
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    applyClick(row, action) {
      let self = this;
      if (action === 'apply') {
        self
          .$confirm('此操作将发起申请, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            SubApplymentApi.applyApplyment(
              {
                applymentId: row.applymentId
              },
              true
            )
              .then(data => {
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.getData();
              })
              .catch(error => {
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消申请'
            });
          });
      } else if (action === 'rollback') {
        self
          .$confirm('此操作将撤回申请, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            SubApplymentApi.rollbackApplyment(
              {
                applymentId: row.applymentId
              },
              true
            )
              .then(data => {
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.getData();
              })
              .catch(error => {
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消撤回'
            });
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pic {
  position: relative;
  width: 60px;
  height: 60px;
  background: #F0F0EE;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/applyment/index.vue